import React from 'react';

import AssignmentChip from './chips/AssignmentChip';
import AssignmentPlaceholderChip from './chips/AssignmentPlaceholderChip';
import DueDateChip from './chips/DueDateChip';
import LabelChip from './chips/LabelChip';
import ReactionChip from './chips/ReactionChip';
import type { ElementChipProps } from './chips/elementChipTypes';

/**
 * Renders a generic element chip descriptor using the matching chip view.
 */
const ElementChip: React.FC<ElementChipProps> = (pill) => {
    switch (pill.type) {
        case 'label':
            return <LabelChip {...pill} />;
        case 'reaction':
            return <ReactionChip {...pill} />;
        case 'assignment':
            return <AssignmentChip {...pill} />;
        case 'assignment-placeholder':
            return <AssignmentPlaceholderChip {...pill} />;
        case 'due-date':
            return <DueDateChip {...pill} />;
        default:
            return null;
    }
};

export default ElementChip;
